import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { EpisodeCard } from "@/components/EpisodeCard";
import { SearchBar } from "@/components/SearchBar";
import { Skeleton } from "@/components/ui/skeleton";

export default function SearchPage() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [results, setResults] = useState(null);

  useEffect(() => {
    if (q.trim().length < 2) { setResults([]); return; }
    setResults(null);
    api.get("/episodes/search", { params: { q } }).then((r) => setResults(r.data)).catch(() => setResults([]));
  }, [q]);

  return (
    <div className="min-h-screen flex flex-col" data-testid="search-page">
      <Navbar />
      <main className="flex-1 w-full max-w-[1400px] mx-auto px-5 sm:px-8 pt-10 pb-32">
        <p className="eyebrow mb-2">Search</p>
        <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tight leading-none">
          {q ? <>Results for <span className="text-sky-400" data-testid="search-query">“{q}”</span></> : "Search episodes"}
        </h1>
        <SearchBar className="mt-6 max-w-xl" autoFocus testId="search-page-input" />
        <div className="mt-10">
          {!results ? (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">{[...Array(8)].map((_, i) => <Skeleton key={i} className="h-40 rounded-2xl bg-white/5" />)}</div>
          ) : results.length === 0 ? (
            <p className="text-slate-400" data-testid="search-empty">{q.trim().length < 2 ? "Type at least two characters to search across every show." : "No episodes matched. Try a different keyword."}</p>
          ) : (
            <>
              <p className="text-sm text-slate-400 mb-4" data-testid="search-count">{results.length} episode{results.length === 1 ? "" : "s"}</p>
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4" data-testid="search-results">
                {results.map((ep, i) => <EpisodeCard key={ep.id} episode={ep} index={i} />)}
              </div>
            </>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
